import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["statusText", "downloadBtn", "errorMessage", "loadingIndicator"]
    static values = {downloadId: String}

    connect() {
        this.checkStatus()
    }

    checkStatus() {
        fetch(`/features/yt_downloaders/${this.downloadIdValue}/status`, {
            headers: {Accept: "application/json"}
        })
            .then(response => response.json())
            .then(data => {
                switch (data.status) {
                    case "pending":
                        this.statusTextTarget.textContent = "Wartet auf Verarbeitung..."
                        break
                    case "in_progress":
                        this.statusTextTarget.textContent = "Download wird bereitgestellt..."
                        break
                    case "finished":
                        this.statusTextTarget.textContent = "Fertig! Klicke auf 'Datei herunterladen'."
                        this.downloadBtnTarget.classList.remove("hidden")
                        this.loadingIndicatorTarget.classList.add("hidden")
                        return // Stop polling
                    case "failed":
                        this.statusTextTarget.textContent = "Fehler aufgetreten!"
                        this.errorMessageTarget.textContent = data.error_message
                        this.loadingIndicatorTarget.classList.add("hidden")
                        return // Stop polling
                }

                // Continue polling
                setTimeout(() => this.checkStatus(), 1000)
            })
            .catch(err => {
                this.statusTextTarget.textContent = "Fehler beim Polling: " + err
                this.loadingIndicatorTarget.classList.add("hidden")
            })
    }

    startDownload() {
        window.location.href = `/features/yt_downloaders/${this.downloadIdValue}/download`
    }
}
